import React, { useContext } from 'react';
import { ReactComponent as ArrowDown } from './assets/arrow-down.svg';
import { createChatMessage } from './react-chatbot-kit/src/components/Chat/chatUtils';
import PlaceHolderLogo from './assets/place-holder-256.png';

import { ActionType, store } from './store';
import './header.css';

type HeaderProps = {
}

function Header({ }: HeaderProps) {
  const globalStore = useContext(store);

  const onClickHeaderBookingBtn = () => {
    globalStore.dispatch({ type: ActionType.SUBMIT_CUSTOMIZED_MESSAGE, payload: '预约' });
    console.log('sentBookingRequestMessage message', '预约');
  }

  const onClickHeaderToggle = () => {
    globalStore.dispatch({ type: ActionType.CHAT_BOT_CONTAINER_TOGGLE, payload: !globalStore.state.chatBotContainerToggle });
  }

  const lawfirmLogo = globalStore.state.config.LawfirmInfo ? globalStore.state.config.LawfirmInfo.LawfirmLogo : PlaceHolderLogo;
  const lawfirmName = globalStore.state.config.LawfirmInfo ? globalStore.state.config.LawfirmInfo.LawfirmName : 'Placeholder';

  return (
    <div style={{
      width: '100%',
      height: '88px',
      backgroundColor: 'white',
    }} className='react-chatbot-kit-chat-header-customized'>
      <div style={{
        padding: '10px 16px 10px 16px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}>
        <img style={{
          width: '40px',
          height: '40px',
          borderRadius: '50px',
          border: '1px',
        }} src={lawfirmLogo} alt={lawfirmName} />
        <div style={{
          backgroundColor: 'white', padding: '10px',
          border: 'Mixed solid #EDEDED',
          fontFamily: 'Source Han Sans CN',
          fontSize: '14px',
          fontWeight: 700,
          lineHeight: '21px',
          textAlign: 'left',
        }}>
            {globalStore.state.config.LawfirmInfo?.LawfirmName}
        </div>
        <ArrowDown
          className="header-toggle-btn"
          onClick={onClickHeaderToggle}
        />
      </div>
      <div style={{
        width: '100%',
        height: '28px',
        background: '#2F59C614',
        display: 'flex', // Use flexbox for alignment
        justifyContent: 'center', // Center horizontally
        alignItems: 'center', // Center vertically
      }}>
        <div className="header-booking-btn" onClick={onClickHeaderBookingBtn}>
          直接预约
        </div>
      </div>
    </div>
  )
}

export default Header;
